import React from 'react';
import { Provider } from 'react-redux';
import ActivitiesFilterPage from './activities-filter-page';
import { combineReducers, createStore } from 'redux';
import { organizersReducer } from '../service/organizers';
import { activitiesReducer } from '../service/activities';
import { catalogReducer } from '../service/catalog';
import { typesReducer } from '../service/types';
import { createRoot } from 'react-dom/client';

export default function initializeActivities(elementOrId: HTMLElement | string): void {
  const store = createStore(
    combineReducers({
      organizers: organizersReducer,
      activities: activitiesReducer,
      catalog: catalogReducer,
      types: typesReducer,
    })
  );
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  const root = createRoot(element);
  root.render(
    <Provider store={store}>
      <ActivitiesFilterPage />
    </Provider>
  );
}
